import axios from "./axiosInstance";

const galleryAPI = {
  listing: () => axios.get("gallery"),
};

export default galleryAPI;